import { css } from '@emotion/css'

export default css(`
  padding: 0 48px 0 0;
  
  &:hover {
    background-color: transparent;
  }
`)
